import { VisitReopenCommand } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent, ModalConfirmButton } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../translations';

import { VisitReopenFormBean, VisitReopenFormController } from './VisitReopenForm';

type VisitReopenModalConfirmButtonProps = Pick<VisitReopenFormController, 'handleSubmit'> & {
   readonly visitId: number;
   readonly onSuccess: VoidFunction;
};

export const VisitReopenModalConfirmButton = (props: VisitReopenModalConfirmButtonProps): JSX.Element => {
   const { executeAsync: reopenVisit } = useCqrsCommand<void, VisitReopenFormBean>(
      (parameters) => {
         const command = new VisitReopenCommand();
         command.reason = parameters.reason!;
         command.visitId = props.visitId;
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(appointmentsTranslationKeys.reopenVisitModal.successMessage);
            props.onSuccess();
         },
      }
   );

   return (
      <ModalConfirmButton
         label={appointmentsTranslationKeys.reopenVisitModal.confirm}
         onClick={props.handleSubmit(reopenVisit)}
      />
   );
};
